import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=47fbaf1e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fbaf1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fbaf1e')) {
      api.createRecord('47fbaf1e', component.options)
    } else {
      api.reload('47fbaf1e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=47fbaf1e&scoped=true&", function () {
      api.rerender('47fbaf1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j5GmkMgYfn87/JS/comp/Accordion.vue"
export default component.exports